<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faDice } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    import Swal from 'sweetalert2'

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let tid = ""
    let sid = ""
    let gid = "";
    let device = 'desktop'
    export let params = {};
    let textLoad = 'Loading...'

    async function getGameURL() {
        // Swal.fire({
        //     title: 'กรุณารอสักครู่',
        //     html: 'เรากำลังพาคุณเข้าสู่เกม ขอให้โชคดี Good Luck.',
        //     timer: 10000,
        //     timerProgressBar: true,
        //     didOpen: () => {
        //         Swal.showLoading()
        //     },
        //     willClose: () => {
                
        //     }
        // }).then((result) => {
        //     if (result.dismiss === Swal.DismissReason.timer) {
                
        //     }
        // })
        loading = true
        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:gid,
                device:device,
                type:"game"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // window.location = json.payload
            // loading = false
            textLoad = 'Transfer'
            transferCash(json.txid,json.payload)
		} else {
            loading = false
            // gameList = []
            throw new Error(json);
		}
        
    }
    async function transferCash(txid,url) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/transfercash", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                txid:txid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            window.location = url
		} else {

            throw new Error(json);
		}
    }
    let promise
    $: {

        if (params &&params.gid) {
            gid = params.gid
            promise = getGameURL()
        } 
    }
</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n">Start Game</h4></div>
    <div class="col-12 " style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-5 border p-5 rounded border-warning" style="">
            <Fa icon={faDice} size="10x" pulse class="text-white"/><br />
            <span class="text-white">{textLoad}</span>
        </div>
        {/if}
        {#if !loading}

        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3">
        <HeaderThemes/>
        <div class="  blog-starts">
            <div class="col-12 text-center mt-5" ><h4 class="head-title">Start Game</h4></div>
            <div class="col-12 " style="min-height: 500px;">
                {#if loading}
                <div class="text-center mt-5 border p-5 rounded border-warning" style="">
                    <Fa icon={faDice} size="10x" pulse class="text-white"/><br />
                    <span class="text-white">{textLoad}</span>
                </div>
                {/if}
                {#if !loading}

                {/if}
            </div>
        </div>
    </div>
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>